import { useState, useEffect } from "react";
import ErrorMessage from "../../common/errorMsg";
import SuccessMessage from "../../common/successMsg";
import httpService from '../../../services/http.service'
import Navbar from './settingNav';
import WarningMessage from "../../common/warnMsg";

const TimeZones = () => {
    const [activeTab] = useState("timezones");
    const [serverTimeZone, setServerTimeZone] = useState("");
    const [selectTimeZone, setSelectTimeZone] = useState("")
    const [serverTime, setServerTime] = useState("")
    const [serverDate, setServerDate] = useState("")
    const [change, setChange] = useState(true)

    const setTimeZone = async (e) => {
        e.preventDefault();
        if (selectTimeZone == serverTimeZone || selectTimeZone == "") {
            WarningMessage("This Time Zone Already Set")
            return;
        }

        const data = { timezone: selectTimeZone };

        try {
            const res = await httpService.CreateUpdate("settimezone", data);
            console.log(res)
            if (res.data.ack === "1") {
                SuccessMessage(res.data.message)
                setChange(!change)

            }
        } catch (error) {
            console.error(error);
        }
    }

    const getTimeZoneData = async () => {
        try {
            const res = await httpService.get("/gettimezone");
            if (res.data.localTime) {
                const dateTimeZone = res.data.localTime.split(' ')
                // Extract date, time, and timezone

                console.log(dateTimeZone[2])
                setServerDate(dateTimeZone[0]);
                setServerTime(dateTimeZone[1]);
                const standardTimeZone = convertToStandardTime(dateTimeZone[2]);
                setSelectTimeZone(standardTimeZone)
                setServerTimeZone(standardTimeZone);
            }
        } catch (error) {
            ErrorMessage("Something went wrong, please try again");
        }
    }
    function convertToStandardTime(timeZoneAbbreviation) {
        switch (timeZoneAbbreviation) {
            case "EDT":
                return "EST";

            case "CDT":
                return "CST"
            case "MDT":
                return "MST"
            case "PDT":
                return "PST"
            case "AKDT":
                return "AKST"
            // case "CDT":
            //     return "CST"
            // Add more cases for other time zones as needed
            default:
                return timeZoneAbbreviation;
        }
    }


    const setTimeZOne = (e) => {

        setSelectTimeZone(e);
    }

    useEffect(() => {
        getTimeZoneData();
    }, [change]);

    return (
        <div>
            <Navbar activeTab={activeTab} />
            <div style={{ margin: "15px" }}>
                <div className="pad-15 mt-5">
                    <div className="form-boxdiv">
                        <div className="form-boxtopline5" style={{ padding: "12px" }}>Time Zone
                        </div>
                        <div className="form-boxtopcont ">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <div>
                                            <form className="slidesharemainform">
                                                <b>Edit the Timezone</b>
                                                <select
                                                    className="form-control"
                                                    value={selectTimeZone}
                                                    onChange={(event) => setTimeZOne(event.target.value)}
                                                    style={{ marginBottom: "10px" }}
                                                >
                                                    {!["EST", "CST", "MST", "PST", "AKST", "HST", "EDT", "CDT", "MDT", "PDT", "AKDT"].includes(serverTimeZone) && (
                                                        <option value="">Select Timezone</option>
                                                    )}
                                                    <option value="EST">Eastern Time</option>
                                                    <option value="CST">Central Time</option>
                                                    <option value="MST">Mountain Time</option>
                                                    <option value="PST">Pacific Time</option>
                                                    <option value="AKST">Alaska Time</option>
                                                    <option value="HST">Hawaii Time</option>
                                                </select>
                                                <div className="row" style={{ marginBottom: "20px" }}>
                                                    <div className="col-6">
                                                        <label><b>Show Time {" "}</b></label>
                                                        <br />
                                                        <input
                                                            type="time"
                                                            // className="checkboxLayout"
                                                            value={serverTime}
                                                            disabled
                                                        ></input>
                                                    </div>
                                                    <div className="col-6">
                                                        <label><b>Show Date {" "}</b></label>
                                                        <br />
                                                        <input
                                                            type="date"
                                                            value={serverDate}
                                                            disabled
                                                        ></input>
                                                    </div>
                                                </div>
                                                <button className="btn btn-primary" onClick={setTimeZone}>Save</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeZones;

